import { defineComponent, ref, computed, createElementBlock, openBlock, normalizeStyle, createElementVNode } from 'vue';

const _hoisted_1 = ["src", "title"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MediaYoutube",
  props: {
    media: {}
  },
  setup(__props) {
    const props = __props;
    const playerRef = ref(null);
    const iframeSrc = computed(() => {
      let iframeSrc2 = "";
      if (props.media.url) {
        iframeSrc2 = props.media.url;
      } else if (props.media.videoId) {
        iframeSrc2 = `https://www.youtube-nocookie.com/embed/${props.media.videoId}?autoplay=${props.media.autoplay ? 1 : 0}&controls=${props.media.displayPlayerInterface ? 2 : 0}`;
      }
      return iframeSrc2;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "media-youtube",
        style: normalizeStyle({ "--ratio": _ctx.media.ratio ? _ctx.media.ratio : "16/9" })
      }, [
        createElementVNode("iframe", {
          ref_key: "playerRef",
          ref: playerRef,
          class: "media-youtube__iframe",
          src: iframeSrc.value,
          title: _ctx.media.title ? _ctx.media.title : void 0,
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
          referrerpolicy: "strict-origin-when-cross-origin",
          allowfullscreen: ""
        }, null, 8, _hoisted_1)
      ], 4);
    };
  }
});

export { _sfc_main as default };
